<script>
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'BookingPendingApprovalsListNonConsecutiveDatesShape',
  mixins: [baseMixin],
}
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="15"
    viewBox="0 0 32 18"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.58744 0.5H8.5C3.80558 0.5 0 4.30558 0 9C0 12.1419 1.70465 14.8856 4.23952 16.3568L9.58744 0.5ZM6.08227 17.1512C6.84859 17.3782 7.66007 17.5 8.5 17.5H23.5C28.1944 17.5 32 13.6944 32 9C32 4.30558 28.1944 0.5 23.5 0.5H11.6981L6.08227 17.1512Z"
      fill="#D9D9D9"
    />
  </svg>
</template>
